<template>
  <!-- spisak kategorija oglasa (stranica oglasa, oglasi prodavca, ocene); izgled isti kao filter na /oglasi (assets/scss/adsFilter.scss) -->
  <div class="afl afl-cats">
    <h5 class="afl-sec-title">Kategorije</h5>

    <ul class="afl-list">
      <li>
        <NuxtLink class="afl-item" to="/oglasi/svi-oglasi/1">
          <span>Sve kategorije</span>
        </NuxtLink>
      </li>

      <li v-for="category in firstCategories" :key="category.id">
        <NuxtLink class="afl-item"
                  :class="{ on: active && category.name === active }"
                  :to="categoryLink(category)">
          <span>{{ category.name }}</span>
        </NuxtLink>
      </li>
    </ul>

    <!-- ostale kategorije iza "Prikaži sve": pravi HTML element (radi i pre hidracije), linkovi su u HTML-u -->
    <details v-if="restCategories.length" class="afl-more" :open="activeInRest">
      <summary>Prikaži sve kategorije ({{ restCategories.length }})</summary>

      <ul class="afl-list">
        <li v-for="category in restCategories" :key="category.id">
          <NuxtLink class="afl-item"
                    :class="{ on: active && category.name === active }"
                    :to="categoryLink(category)">
            <span>{{ category.name }}</span>
          </NuxtLink>
        </li>
      </ul>
    </details>
  </div>
</template>

<script setup>
const routePath = useRoutePath()
const { $srbTolat } = useNuxtApp()

const props = defineProps({
  categories: { type: Array, default: () => [] },
  // kategorija trenutnog oglasa (naziv); ako je zadata, u spisku je istaknuta
  active: { type: String, default: '' },
  // koliko kategorija se odmah vidi; ostale su iza "Prikaži sve kategorije" (0 = sve se vide)
  limit: { type: Number, default: 0 },
})

const list = computed(() => (Array.isArray(props.categories) ? props.categories : []))
const firstCategories = computed(() => (props.limit > 0 ? list.value.slice(0, props.limit) : list.value))
const restCategories = computed(() => (props.limit > 0 ? list.value.slice(props.limit) : []))

// izabrana kategorija je medju skrivenima: lista je odmah otvorena
const activeInRest = computed(() => !!props.active && restCategories.value.some((c) => c.name === props.active))

const categoryLink = (category) =>
  routePath({ name: 'oglasi-category-page', params: { category: $srbTolat.srbTolat(category.name), page: 1 } })
</script>
